import React, { useEffect, useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import ModalWrapper from 'components/ModalWrapper'
import Information from './Information'
import { useDispatch, useSelector } from 'react-redux'
import Members from './Members'
import FooterAddUser from './Members/FooterAddUser'
import Files from './Files'

const ModalChannelView = ({
  isOpenModal,
  toggleOpen,
  conversation = {},
  conversationAction
}) => {
  const [menuSelected, setMenuSelected] = useState('information')
  const dispatch = useDispatch()
  const { user, tabs } = useSelector(state => state)
  const [errorModal, setErrorModal] = useState('')
  const { type, private: isPrivate, name } = conversation
  const isChannel = type === 'channel'
  const isGroup = type === 'group'
  const isDirectMessage = type === 'direct'

  const initialState = [
    {
      isEnable: true,
      name: lang('dashboard_information'),
      id: 'information'
    },
    {
      isEnable: true,
      name: lang('dashboard_members'),
      id: 'members'
    },
    {
      isEnable: true,
      name: lang('dashboard_files'),
      id: 'files'
    }
  ]

  const [menuView, setMenuView] = useState(initialState)

  useEffect(() => {
    if(isDirectMessage) {
      setMenuView(menuView.filter((menu) => menu.id !== 'members'))
    }else{
      setMenuView(initialState)
    }
  }, [conversation])

  const handleToggleOpen = () => {
    toggleOpen()
    setErrorModal('')
    setMenuSelected('information')
  }

  const renderOptions = (id) => {
    switch (id) {
      case 'information':
        return <div className='inchat-channel-view__content'>
          <Information
            conversation={conversation}
            conversationAction={conversationAction}
            dispatch={dispatch}
            toggleOpen={handleToggleOpen}
            tabs={tabs}
            isChannel={isChannel}
          />
        </div>

      case 'members':
        return (
          <div>
            <div className={`
            inchat-channel-view__content
            inchat-channel-view__content--members
            ${!isGroup ? 'inchat-channel-view__content--members--footer' : ''}
            `}>
              <Members
                conversation={conversation}
                conversationAction={conversationAction}
                operatorId={user.id}
                toggleOpen={handleToggleOpen}
                dispatch={dispatch}
                tabs={tabs}
                isGroup={isGroup}
              />
            </div>
            {!isGroup &&
              <FooterAddUser
                conversation={conversation}
                conversationAction={conversationAction}
                setErrorModal={setErrorModal}
              />
            }
          </div>
        )
      case 'files':
        return <div className='inchat-channel-view__content inchat-channel-view__content--files'>
          <Files
            conversation={conversation}
            setErrorModal={setErrorModal}
          />
        </div>

      default:
        return <></>
    }
  }

  return (
    <>
      <ModalWrapper
        isOpen={isOpenModal}
        toggle={handleToggleOpen}
        header={isChannel ? name : lang(`dashboard_${type}`) }
        iconName={isChannel ? isPrivate ? 'icon-channel-private' : 'icon-channel' : null}
        contentClassName={'inchat-modal-container'}
        body={
          <div className='inchat-channel-view'>
            <div className='inchat-channel-view__menu-container'>
              <div
                className='inchat-channel-view__menu-options'
              >
                {menuView.map(menu => (
                  <span
                    className={`
                      inchat-channel-view__menu-options--span
                      ${menuView.length === 2 ? 'inchat-channel-view__menu-options--span-1' : 'inchat-channel-view__menu-options--span-2'}
                    `}
                    key={menu.id}
                    style={{
                      color: menuSelected === menu.id
                        ? '#ffffff'
                        : '#333333',
                      backgroundColor: !menu.isEnable
                        ? '#e6e6e6'
                        : menuSelected === menu.id
                          ? '#333333'
                          : '#ffffff',
                      cursor: menu.isEnable ? 'pointer' : 'initial'
                    }}
                    onClick={() => {
                      if (menu.isEnable) {
                        setMenuSelected(menu.id)
                        setErrorModal('')
                      }
                    }}
                  >
                    {menu.name}
                  </span>
                ))}
              </div>
            </div>
            {renderOptions(menuSelected)}
          </div>
        }
        error={errorModal}
        isSubmitting={false}
        footer={errorModal ? <></> : undefined }
      />

    </>
  )
}

export default ModalChannelView